export enum authCookies {
  TOKEN = 'yarmill-diary-auth-token',
}

export interface LoginServerError {
  error: string;
  error_description: string;
}
